import { goJoinEvent } from "@/lobby_common/utils/utils.js";
import { getLocalStorage, setLocalStorage } from "@/lobby_common/utils/auth.js";
import { getRedDot } from "@/lobby_common/api/activity_gen.js";
import { RedDotTypeMap } from "@/lobby_common/utils/commonEnum.js";
export default {
  name: "mode2",
  components: {},
  data() {
    return {
      cur_left: 0,
      max_left: 0,
      timer: null,
      content_index: undefined,
      startX: "",
      endX: "",
      redDotMap: {},
    };
  },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    specialRedDot() {
      return this.$store.getters.getSpecialRedDot;
    },
    enableExchangeTips() {
      return this.$store.getters.getEnableExchangeTips;
    },
    isLogin() {
      return this.$store.getters.login;
    },
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    showType() {
      return this.item?.showType || 1;
    },
    num() {
      return this.IsMobile ? 1 : 2;
    },
    getImgHeight() {
      const containerWidth =
        document.body.clientWidth > 1340
          ? 1280
          : document.body.clientWidth - 60;
      const num = 360 / 640;
      const imgWidth = this.IsMobile ? containerWidth : containerWidth * 0.47;
      return imgWidth * num;
    },
    arrContent() {
      const arr = [];
      this.item.list.map((v, i) => {
        if (v.status !== 0) {
          arr.push({
            ...v,
            uid: v.uid || window.crypto.randomUUID(),
            eid: `101_13_${this.curindex}_${i}`,
          });
        }
      });
      this.content_index = this.curindex;
      if (arr.length % this.num > 0) {
        // 不能整除
        this.max_left = Math.floor(arr.length / this.num) * 100;
      } else {
        // 能整除
        this.max_left = (Math.floor(arr.length / this.num) - 1) * 100;
      }

      return [...arr];
    },
    lang() {
      return this.$store.getters.getLang;
    },
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config
        ?.titleAlignment;
    },
    wsExchangeTips() {
      return this.$store.getters.getShowWithdrawGuideText;
    },
    showExchangeTips() {
      if (this.wsExchangeTips === null) {
        return this.enableExchangeTips;
      }
      return this.enableExchangeTips || this.wsExchangeTips;
    },
  },
  watch: {
    specialRedDot: {
      handler(newVal) {
        this.updateRedDot(newVal || []);
      },
      immediate: true,
    },
  },
  methods: {
    getSpan(i) {
      if (this.IsMobile) {
        if (i < 2) {
          return 12;
        } else {
          return 6;
        }
      } else {
        if (i < 3) {
          return 8;
        } else {
          return 4;
        }
      }
    },
    changePosition(dir = "left") {
      const that = this;
      const dom = document.querySelector(`.content_${this.curindex}`);
      if (dom) {
        const target =
          dir === "left" ? that.cur_left - 100 : that.cur_left + 100;
        // if(that.cur_left === 0) dom.style.left = 0
        // else dom.style.left = `-${that.cur_left}00%`
        this.animateDom(target, dom, dir);
      }
    },
    animateDom(target, dom, dir) {
      const that = this;
      if (that.timer) {
        return false;
      }
      // let timer = that.timer;
      that.timer = setInterval(function () {
        const speed = dir === "left" ? -5 : 5; // 判断是向左走（负）还是向右走（正）
        // console.log(dir, that.cur_left, target)
        if (that.cur_left === target) {
          clearInterval(that.timer);
          that.timer = null;
        } else {
          that.cur_left = this.IsMobile ? that.cur_left : that.cur_left + speed;
          if (that.cur_left === 0) dom.style.left = 0;
          else dom.style.left = `-${that.cur_left}%`;
        }
      }, 10);
    },
    handelClick(item, index) {
      // const jump = item.jump || {};
      this.$eventPost("click", {
        eid: item.eid,
        time: Date.now(),
        jump_value: item.jump,
      });
      this.$eventPost("featured_modules", {
        SubFeaturedModulesLocation: index,
      });
      // 首次显示
      if (this.redDotMap[item.uid] && this.redDotMap[item.uid].isNew) {
        this.$set(this.redDotMap, item.uid, null);
      }
      const SPECIAL_DATA = getLocalStorage(`SPECIAL_DATA`) || {};
      SPECIAL_DATA[this.item.uid] = SPECIAL_DATA[this.item.uid] || {};
      SPECIAL_DATA[this.item.uid][item.uid] = true;
      setLocalStorage(`SPECIAL_DATA`, SPECIAL_DATA);
      // goJoinEvent(jump);
      const { multipleGame, type } = item?.jump;
      if (type === "Jump_TYPE_MULTIPLE_GAME") {
        if (
          multipleGame &&
          multipleGame?.secondaryJump1 &&
          multipleGame?.secondaryJump1 !== "-1"
        ) {
          // 设置了 二级界面跳转位置
          goJoinEvent({
            ...item?.jump,
            title: item?.langInfoObj[this.lang]?.title,
          });
          return;
        }
        // 默认跳搜索
        item["bindType"] = 1;
        localStorage.setItem("Cur_params", JSON.stringify(item));
        this.$router.push({ name: "homeSearch" });
        return;
      }
      // 非多款游戏
      goJoinEvent(item?.jump);
    },
    touchStart(e) {
      this.startX = e.touches[0].clientX;
    },
    touchEnd(e) {
      this.endX = e.changedTouches[0].clientX;
      // 在滑动超过一定的距离时再切换题目
      if (Math.abs(this.endX - this.startX) < 30) return;
      // 判断，向左还是向右
      if (this.endX > this.startX) {
        // 向左
        if (this.max_left > 0 && this.cur_left > 0) this.changePosition("left");
      } else {
        // 向右
        if (this.max_left > 0 && this.cur_left < this.max_left) {
          this.changePosition("right");
        }
      }
    },
    async updateRedDot(redDot) {
      // 公共逻辑 有奖励则显示红点
      try {
        if (!redDot) {
          const res = await getRedDot();
          if (res.code === 0) {
            redDot = res.data.redDot || [];
          }
        }
        // this.redDotMap = {};
        this.arrContent.forEach((v) => {
          if (v?.jump?.type === "Jump_TYPE_FUNCTION") {
            if (redDot.includes(RedDotTypeMap[v?.jump?.functionType])) {
              this.$set(this.redDotMap, v.uid, {
                src: require("@/assets/task/claim.png"),
                isNew: false,
              });
            } else if (!this.redDotMap[v.uid]?.isNew) {
              this.$set(this.redDotMap, v.uid, null);
            }
          } else if (v?.jump?.type === "JUMP_TYPE_TASK_CENTER") {
            if (redDot.includes("RED_DOT_TYPE_TASK")) {
              this.$set(this.redDotMap, v.uid, {
                src: require("@/assets/task/claim.png"),
                isNew: false,
              });
            } else if (!this.redDotMap[v.uid]?.isNew) {
              this.$set(this.redDotMap, v.uid, null);
            }
          }
        });
      } catch (error) {}
      this.updateRedDotByConfig();
    },
    async updateRedDotByConfig() {
      if (this.isLogin) {
        // 是否配置了提现跳转
        // const hasExchangeJump = this.arrContent.find(v => v?.jump?.functionType === 'JUMP_FUNCTION_TYPE_WITHDRAW')
        // console.log('hasExchangeJump=>', hasExchangeJump)
      }
      // 根据配置展示
      this.arrContent.forEach((item) => {
        item.isExchange =
          item?.jump?.functionType === "JUMP_FUNCTION_TYPE_WITHDRAW";
        // 不展示
        if (item.redDotType === 0) {
          // this.redDotMap[item.uid] = false;
        } else if (item.redDotType === 1 && !this.redDotMap[item.uid]) {
          // 首次显示
          const SPECIAL_DATA = getLocalStorage(`SPECIAL_DATA`) || {};
          if (
            !SPECIAL_DATA ||
            !SPECIAL_DATA[this.item.uid] ||
            !SPECIAL_DATA[this.item.uid][item.uid]
          ) {
            this.$set(this.redDotMap, item.uid, {
              src: require("@/assets/task/new.png"),
              isNew: true,
            });
            // SPECIAL_DATA[this.item.uid] = SPECIAL_DATA[this.item.uid] || {};
            // SPECIAL_DATA[this.item.uid][item.uid] = true;
            // setLocalStorage(`SPECIAL_DATA`, SPECIAL_DATA);
          }
        }
      });
    },
  },
  mounted() {
    this.updateRedDotByConfig();
  },
};
